import { routeInfo } from '../routeInfo';
import errorCodes from './errorCodes';
import messages from './messages';

const errorMessages = {
    [errorCodes.projectAlreadyExist]: messages.projectAlreadyExists,
    [errorCodes.scriptAlreadyExist]: messages.scriptAlreadyExists,
    [errorCodes.conversationAlreadyExist]: messages.conversationAlreadyExists,
    [errorCodes.tagAlreadyExist]: messages.tagAlreadyExists,
    [errorCodes.userAlreadyExist]: 'An account with that email already exists. Please log in',
    [errorCodes.userAlreadyVerified]: 'This email is already verified',
    [errorCodes.invalidPassword]: 'Invalid password',
    [errorCodes.passwordTooShort]: 'Password is too short, it should be at least 8 characters',
    [errorCodes.invalidPreviousPassword]: `Wrong current password. Try again or <a href="${routeInfo.restorePassword.path}">reset it</a>`,
    [errorCodes.projectNotFound]: 'Project not found',
    [errorCodes.scriptNotFound]: 'Script not found',
    [errorCodes.taggedScript]: 'You cannot delete scripts in previous versions',
    [errorCodes.userNotFound]: 'User not found',
    [errorCodes.userNotApproved]: 'hasn’t been approved yet',
    [errorCodes.emailNotConfirmed]: "Email has not been verified",
    [errorCodes.userProfileNotFound]: 'User profile not found',
    [errorCodes.setProdTag]: "Error occurred while switching a production version. Please contact support",
    [errorCodes.setStageTag]: "Error occurred while switching a stage version. Please contact support",
    [errorCodes.updateProjectTags]: 'Error happened while we\'re switching to this version. Please contact support',
    [errorCodes.deleteProject]: "Error occurred while switching to this version. Please contact support",
    [errorCodes.scriptNameLengthExceed]: 'Max script length: 50 characters',
    [errorCodes.projectNameLengthExceed]: 'Max project length: 50 characters',
    [errorCodes.verificationEmailSent]: 'Verification email has already been sent. Check your inbox',
    [errorCodes.lastExtraScripts]: 'Last version contains scripts which are absent in current version:',
    [errorCodes.passwordAlreadyChanged]: 'Your password reset link has already been used. Please request a new link',
    [errorCodes.userTriesDeleteProdTagId]: messages.cannotDeleteCurrentVersionFromProd,
    [errorCodes.createCustomerError]: 'An error occurred: could not create a customer',
    [errorCodes.customerNotExists]: 'Customer not exists',
    [errorCodes.balanceNotExists]: 'Balance not exists',
    [errorCodes.userIsSuspended]: `You reached your usage limit. Check your <a href="${routeInfo.billing.path}">Billing page</a>.`,
    [errorCodes.promoNotFound]: 'Promo not found',
    [errorCodes.promoNotApplicable]: 'Promo code cannot be applied on this account',
    [errorCodes.promoAlreadyApplied]: 'Promo code has already been used on this account',
    [errorCodes.oauthFailedSignin]: 'Failed to authorize using google',
    [errorCodes.paymentOtherError]: 'Error happened during the payment process. Please contact support',
    [errorCodes.scriptError]: 'There are errors in the scripts',
    [errorCodes.invalidAuthResponse]: 'Error occurred while authenticating. Please refresh the page',
    [errorCodes.unauthorized]: 'Some error occurred. Please contact support',
    [errorCodes.invalidEmail]: 'Your email is invalid. Please check your email and try again',
    [errorCodes.noGithubLogin]: 'No data about your Github account.  Please re-connect your Github account',
    [errorCodes.unathorizedInGithub]: 'Failed to authorize using Github. Please re-connect your Github account',
    [errorCodes.notPaidUser]: 'You need to add funds to change the plan',
    [errorCodes.notEnoughMoney]: "You don't have enough funds to change the plan. Please add funds to your balance",
    [errorCodes.undefinedGithubToken]: "Your GitHub token has expired. Please re-sync your project with GitHub",
    [errorCodes.invalidGithubToken]: "Your GitHub token has expired. Please re-sync your project with GitHub",
    [errorCodes.githubRepoError]: "We were unable to receive a response from GitHub. Please try later",
    [errorCodes.githubRepoNotFound]: "The GitHub repo is not found",
    [errorCodes.githubRepoDirNotFound]: "The directory does not exist in your GitHub repository",
    [errorCodes.planAlreadyCancelled]: "The plan is already cancelled",
    [errorCodes.planAlreadyResumed]: "The plan is already resumed",
    [errorCodes.planAlreadyConfirmed]: "The plan is already confirmed",
    [errorCodes.cardVerificationRequired]: "You need to have saved card for switching to the Periodic Plan",
    [errorCodes.planCancelled]: "You can't approve your personal data plan because it was cancelled. Please contact your Sales Representative",
    [errorCodes.passwordIsEmpty]: "Your password can't start or end with a blank space",
    [errorCodes.decryptionError]: "Some scripts in your project are unavailable",
    [errorCodes.invitationEmailWasResent]: "This user is already invited",
    [errorCodes.buttonOptionsAlreadyExists]: "The button style name already exists, please choose another name",
    [errorCodes.orgExists]: "Organization already exists",
    [errorCodes.orgUserExists]: "The user is already a member of this organization",
    [errorCodes.userDiffOrg]: "The user is a member of another organization",
    [errorCodes.orgUserNotExists]: "Organization user does not exist",
    [errorCodes.orgNotFound]: "Organization not found",
    [errorCodes.orgWithMembers]: "Can't remove organization with active members",
    [errorCodes.userOrgOwner]: "User has already created organization",
    [errorCodes.moneyAmountGreaterHundred]: "The promo amount cannot exceed $100",
    [errorCodes.invalidCall]: "An unexpected error occurred. Please try again later.",
};

export default errorMessages;